import React, { useState, useRef } from "react";
import { useOnClickOutside } from "../hooks";
import { Link } from "react-router-dom";

import SidebarButton from "./SidebarButton";
import SidebarMenu from "./SidebarMenu";
import SearchOverlayButton from "./SearchOverlayButton";
import SearchOverlay from "./SearchOverlay";

const Navbar = () => {
  const [open, setopen] = useState(false);
  const [on, setOn] = useState(false);

  const SidebarNode = useRef();
  useOnClickOutside(SidebarNode, () => setopen(false));

  const handleClick = (e) => {
    setOn(!on)
  }
  const overlayID = "search-overlay";

  return (
    <nav className="sticky top-0 bg-gray-800 text-white shadow-2xl z-20 w-screen mx-auto px-2 sm:px-4 lg:px-20 xl:px-40">
      <div className="flex items-center justify-between lg:justify-start h-16">
        <div ref={SidebarNode} className="flex lg:hidden">
          <SidebarButton
            open={open}
            setopen={setopen}
            aria-controls="main-menu"
            className={`${
              open ? null : "lg:hidden"
            } relative m-2 z-40 flex flex-col justify-around w-8 h-8 bg-transparent cursor-pointer border-none`}
          />
          <SidebarMenu className="z-30" open={open} setopen={setopen} id="main-menu" />
        </div>
        <div className="flex-shrink-0">
          <Link to="/">
            <h1 className="font-extrabold text-3xl italic text-white hover:text-purple-400 transition duration-100 ease-in-out lg:pr-3">
              StoicWisdom
            </h1>
          </Link>
        </div>
        <div className="flex hidden lg:block ">
          <Link
            to="/philosophers"
            className="text-lg mx-2 px-3 py-2 rounded-md text-sm font-medium leading-5 text-white hover:text-purple-400 focus:outline-none focus:text-purple-400 focus:bg-gray-900 transition duration-150 ease-in-out"
          >
            Philosophers
          </Link>
          <Link
            to="/topics"
            className="text-lg mx-2 px-3 py-2 rounded-md text-sm font-medium leading-5 text-white hover:text-purple-400 focus:outline-none focus:text-purple-400 focus:bg-gray-900 transition duration-150 ease-in-out"
          >
            Topics
          </Link>
          <Link
            to="/random"
            className="text-lg mx-2 px-3 py-2 rounded-md text-sm font-medium leading-5 text-white hover:text-purple-400 focus:outline-none focus:text-purple-400 focus:bg-gray-900 transition duration-150 ease-in-out"
          >
            Random
          </Link>
          <Link
            to="/all"
            className="text-lg mx-2 px-3 py-2 rounded-md text-sm font-medium leading-5 text-white hover:text-purple-400 focus:outline-none focus:text-purple-400 focus:bg-gray-900 transition duration-150 ease-in-out"
          >
            Quotes
          </Link>
          <Link
            to="/api"
            className="text-lg mx-2 px-3 py-2 rounded-md text-sm font-medium leading-5 text-white hover:text-purple-400 focus:outline-none focus:text-purple-400 focus:bg-gray-900 transition duration-150 ease-in-out"
          >
            API
          </Link>
        </div>
        <div className="flex lg:absolute lg:right-20 xl:right-40">
        <Link
            to="/search">
            <SearchOverlayButton 
            // onClick={handleClick}
            // on={on}
            // aria-controls={overlayID}

            className="inline-flex items-center p-2 rounded-md text-white hover:text-purple-400 transition duration-150 ease-in-out"
            />
          </Link>
          {/* <SearchOverlay on={on} setOn={setOn} id={overlayID} className="overlay" /> */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
